import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {CommonModule} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import {ViewImageComponent} from './view-image.component';
import {TreoCardModule} from '../../../../@treo/components/card';

@NgModule({
    declarations: [
        ViewImageComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatInputModule,
        MatProgressSpinnerModule,
        TreoCardModule,
    ],
    exports: [
        ViewImageComponent
    ]
})
export class ViewImageModule {
}
